import { Component, ElementRef, OnInit, ViewChild, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Agent } from '../../classes/agent';
import { ListingsService } from '../../services/listings.service';
import { ViewModes, ListingCategory } from '../../classes/enums';
import { AgentService } from '../../services/agent.service';
import { DetailStub } from '../listing-details/detail-section/detail-section.component';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UserService } from '../../services/user.service';
import { HasSubscriptions } from '../has-subscriptions';
import { User } from '../../classes/user';
import { OfficeService } from '../../services/office.service';
import { CommunicationService } from '../../services/communication.service';
import { Office } from '../../classes/office';
import { HistoryItem } from '../../classes/history-item';
import { PreRenderService } from '../../services/pre-render.service';
import { RoutingHistoryService } from '../../services/routing-history.service';
import { MetaTagService } from '../../services/meta-tag.service';
import { DomManipulationService } from '../../services/dom-manipulation/dom-manipulation.service';
import { StyleService } from '../../services/style/style.service';
import { SCREEN_SIZE } from '../../classes/enums';
import { merge, forkJoin } from 'rxjs';
import { Pagination } from '../../classes/pagination';
import { Listing } from '../../classes/listing';
import {ChatService} from '../../services/chat.service';
import { RankMyAgentService } from '../../services/rank-my-agent.service';
import { PreferencesService } from '../../services/preferences.service';
import { IBlogResponse, IFooterLinks, ICmsLink, IInternalLinksResponse } from '../../classes/interfaces';
import { BlogService } from '../../services/blog.service';
import { InternalLinksService } from '../../services/internalLinks.service';

@Component({
  template: '<fake>'
})
export class PageProfileComponent extends HasSubscriptions implements OnInit {


  @ViewChild('contactAgentMobile') contactAgentMobileRef: ElementRef;

  isLoading: boolean = true;
  fastFactRows: DetailStub[] = [];
  contactForm: FormGroup;

  // Have they sent in a request to contact the agent
  showRequestSent: boolean = false;
  hasRetrievedSuggestedListings: boolean = false;

  showContactForm: boolean = false;
  contactName: string = '';

  // Enum
  ViewModes = ViewModes;
  ListingCategory = ListingCategory;
  listingsPagination: Pagination = new Pagination();

  productSchema = [];

  minListingsLeftBeforeRetrievingNew: number = 4;

  internalLinks = Array<ICmsLink>();

  protected _user: User;
  listingCategory: ListingCategory;
  screenSize: SCREEN_SIZE;
  SCREEN_SIZE = SCREEN_SIZE;

  // TODO: get rid of some of the services here unless neded
  constructor(protected route: ActivatedRoute,
              protected listingsService: ListingsService,
              protected router: Router,
              protected translate: TranslateService,
              protected activatedRoute: ActivatedRoute,
              protected fb: FormBuilder,
              protected officeService: OfficeService,
              protected userService: UserService,
              protected communicationService: CommunicationService,
              protected renderer: Renderer2,
              protected rankService: RankMyAgentService,
              protected prerenderService: PreRenderService,
              protected agentService: AgentService,
              protected metaTagService: MetaTagService,
              protected domManipulationService: DomManipulationService,
              protected chatService: ChatService,
              protected historyService: RoutingHistoryService,
              protected preferenceServices: PreferencesService,
              protected blogService: BlogService,
              private styleService: StyleService) {
    super();
    this.domManipulationService.scrollToTop();
  }

  pushHistory(history: HistoryItem): void {
    this.historyService.push(history);
  }

  ngOnInit() {

    this.contactForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', Validators.required],
      phone: [{ value: '', disabled: true }, [Validators.required, Validators.maxLength(13)]],
      contactByPhone: [false],
      contactType: ['no-pref'],
      buy: [false],
      sell: [false],
      comments: ['']
    });

    // Set a default message
    this.translate.get('contact.generic-intro').toPromise().then((s) => this.contactForm.patchValue({ comments: s }));
    this.addSub(
    merge(this.contactForm.get('buy').valueChanges, this.contactForm.get('sell').valueChanges).subscribe(() => {
      const buy = this.contactForm.get('buy').value;
      const sell = this.contactForm.get('sell').value;

      const commentsText = buy && sell
        ? this.translate.instant('page-profile.looking-buy-and-sell')
        : (buy ? this.translate.instant('page-profile.looking-buy')
          : (sell ? this.translate.instant('page-profile.looking-sell')
            : '')
        );
      this.contactForm.patchValue({
        comments: commentsText
      });
    }));

    this.addSub(this.contactForm.get('contactByPhone').valueChanges.subscribe((value) => {
      if (value) this.contactForm.controls['phone'].enable();
      else this.contactForm.controls['phone'].disable();
      this.contactForm.get('phone').updateValueAndValidity();
    }));

    this.addSub(this.communicationService.listings.currentShownListingType.subscribe((selectedListingType) => {
      this.listingCategory = selectedListingType;
    }));

    this.addSub(this.communicationService.screenSize.subscribe((screenSize) => {
      this.screenSize = screenSize;
      if (this.screenSize === SCREEN_SIZE.MOBILE_ONLY) {
        this.minListingsLeftBeforeRetrievingNew = 3;
      }
      else {
        this.minListingsLeftBeforeRetrievingNew = 7;
      }
    }));
  }

  setUserDetailsForContactForm(user?: User) {
    this._user = user;
    if (this._user.email) {
      const commentsText = this._user.buy && this._user.sell
        ? this.translate.instant('page-profile.looking-buy-and-sell')
        : (this._user.buy ? this.translate.instant('page-profile.looking-buy')
          : (this._user.sell ? this.translate.instant('page-profile.looking-sell')
            : '')
        );
      this.contactForm.patchValue({
        email: this._user.email,
        name: this._user.name,
        buy: this._user.buy,
        sell: this._user.sell,
        comments: commentsText
      });
    }
  }

  openContactAgentOrOfficeForm(contactObject: (Agent | Office)) {
    this.showContactForm = true;

    if (contactObject) {
      this.contactName = contactObject instanceof Office ? (<Office>contactObject).officeName : (<Agent>contactObject).fullName;
      this.contactForm.patchValue({ comments: this.translate.instant('contact.generic-intro-with-name', { name: this.contactName }) });
    }
    else {
      this.contactForm.patchValue({ comments: this.translate.instant('contact.generic-intro') });
    }
    this.styleService.addClass(this.renderer, 'body', 'with-side-nav');
  }

  onListingsClicked(listing) { }

  onSlideChanged(event: { card: Listing, index: number }) {
    // We've already fetched all we can, so stop fetching
    // FIXME: we're seeing a double action occur when less than initial offset listings
    if (this.listingsPagination.pageNumber > this.listingsPagination.totalPages) return;

    // If we're almost at the end of the listings, try and get some more
    if (event.index >= this.listingsPagination.offset - this.minListingsLeftBeforeRetrievingNew) {
      this.listingsPagination.pageNumber++;
      this.getMoreListings();
    }
  }

  getMoreListings() { }

  getCmsLinks(province: string, city: string) {
    this.communicationService.footerLinksChange.next({ city: city, province: province });
  }

}
